import React, { Component, Fragment } from "react";
import { connect, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import axios from "axios";

import PrivateRouteWrapper from "./PrivateRouteWrapper";
import Header from "../components/wrapper/Header/Header";
import SideBar from "../components/wrapper/SideBar/SideBar";
import Content from "../components/wrapper/Content/Content";
import Map from "../pages/client/MapPage";
import Analytics from "../pages/client/AnalyticsPage";
import Loading from "../components/wrapper/Loading/Loading";
import * as actionTypes from "../store/actions/actionTypes";

import truckColors from "../assets/truckRouteColors";
import blendedColors from "../assets/blendedRouteColors";
import macroColors from "../assets/macroRouteColors";
import repColors from "../assets/repRouteColors";

import classes from "./ClientPage.module.scss";
import { Button, Spinner } from "reactstrap";


import _ from "lodash";
import MapPageTemp from "../pages/client/MapPageTemp";
import AnalyticsPageTemp from "../pages/client/AnalyticsPageTemp";

const inventoryCampaigns = {
  LA: 71,
  NYC: 72,
  SF: 73
};

class ClientWrapper extends Component {
  state = {
    loading: false,
    loadedUser: false,
    hasAcceptedTermsAndConditions: undefined,
    acceptTermsAndConditionsLoading: false,
    userId: null,
    isInitialCallMade: false,
    userProfileUrl: null,
  };

  componentDidMount() {
    const userId = this.props.userId ? this.props.userId : JSON.parse(localStorage.getItem("userId"))

    this.setState({
      userId
    })

    this.checkIfUserAcceptedTermsAndConditions(userId)
  }

  checkIfUserAcceptedTermsAndConditions = (userId) => {
    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/check-if-user-accepted-terms/${userId}`)
      .then((response) => {
        this.setState({
          hasAcceptedTermsAndConditions: response.data.has_accepted_terms_and_conditions
        });
        localStorage.setItem("has_accepted_terms_and_conditions", JSON.stringify(response.data.has_accepted_terms_and_conditions));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.hasAcceptedTermsAndConditions && !this.state.isInitialCallMade) {
      this.loadUser(this.state.userId, this.props.timePeriod, true, prevProps.campaigns[this.props.selected]);
      this.loadUserDetail(this.state.userId)
      this.setState({
        isInitialCallMade: true,
        loadedUser: true
      })
    }
    if (this.props) {
      
      if (this.state.hasAcceptedTermsAndConditions && (this.props.timePeriod !== prevProps.timePeriod || (this.props.selected !== prevProps.selected && this.props.selected !== 0 && prevProps.selected !== 0 || ( this.props.location.pathname.includes('map') !== prevProps.location.pathname.includes('map'))))) {
        // this.props.updateCampaignVehiclesTemp(0, {})
        if (this.state.userId && !this.state.loadedUser) {
          this.loadUser(this.state.userId, this.props.timePeriod, this.props.selected !== prevProps.selected ? true : false, prevProps.campaigns[this.props.selected]);
          this.loadUserDetail(this.state.userId)
          this.setState({
            loadedUser: true
          });
        } else {
          // check if vehicles exist if selected campaign changes
          if (prevProps.selected !== this.props.selected) {
            let selected = this.props.selected;
            if (
              this.state.campaigns[selected]
            ) {
              let vehicles = await this.getVehicles(selected, this.props.timePeriod, true, prevProps.campaigns[this.props.selected]);
              this.props.updateCampaignVehiclesTemp(selected, vehicles)
            }
          } else {
            let selected = this.props.selected;
            if (
              this.state.campaigns[selected] &&  this.props.location.pathname.includes('map')
              ) {
              let vehicles = await this.getVehicles(selected, this.props.timePeriod, false, prevProps.campaigns[this.props.selected]);
              this.props.updateCampaignVehiclesTemp(selected, vehicles)
            }
          }
        }
      }
    }
  }

  loadUserDetail(userId) {
    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/${userId}`, { withCredentials: true })
      .then(async (response) => {
        
        let user = response.data.user[0];
        if(user?.user_id && user?.user_profile_image){
          this.props.updateProfilePicture(user?.user_profile_image)
        }
      })
  }

  loadUser(userId, timePeriod, fetchAnalytics, campaign) {
    let inventory = this.props.match.params.inventory ? inventoryCampaigns[this.props.match.params.inventory] : null;

    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/${userId}/campaign`, { withCredentials: true })
      .then(async (response) => {
        let campaigns = {};
        let first = null;
        if (response.data.campaigns[0].id) {
          response.data.campaigns.map((campaign) => {
            if (!first) {
              first = campaign.id;
            }
            campaigns[campaign.id] = {
              name: campaign.name,
              vehicles: {},
              csv_report_enabled: campaign.csv_report_enabled,
              startDate: campaign.start_date,
              endDate: campaign.end_date
            };
          });
        }
        else {
          first = 0;
          campaigns[0] = {
            name: "",
            vehicles: {}
          };
        }
        if (first) {
          // load first campaigns routes
          campaigns[first].vehicles = await this.getVehicles(first, timePeriod, fetchAnalytics, campaign);
        }
        this.setState({
          campaigns: campaigns
        });
        this.props.onCampaignLoad(campaigns, inventory ? inventory : first);
        this.props.updateCampaignVehiclesTemp(first, campaigns[first].vehicles)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async getVehicles(id, timePeriod, fetchAnalytics, campaign) {
    const tempCampaignVehicles = campaign ? _.cloneDeep(campaign?.vehicles) : {}
    this.setState({
      loading: true
    });
    let vehicles = {};
    let analytics = {};
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/truck/routes/${timePeriod}`, {
        withCredentials: true
      });
      if (res.status === 200) {
        res.data.trucks.map((truck, index) => {
          let colorIndex = index % truckColors.length;
          if (truck.id) {
            vehicles[`truck-${truck.id}`] = {
              imei: truck.imei,
              name: truck.display_name,
              paths: truck.paths,
              color: truckColors[colorIndex]
            };
          }
        });
        res.data.blended.map((blended, index) => {
          let colorIndex = index % blendedColors.length;
          if (blended.paths && blended.paths.length > 0) {
            vehicles[`blended-${blended.id}`] = {
              name: blended.display_name,
              paths: blended.paths,
              color: blendedColors[colorIndex]
            };
          }
        });
        res.data.placeholders.map((placeholder, index) => {
          let colorIndex = index % repColors.length;
          vehicles[`placeholder-${placeholder.id}`] = {
            name: placeholder.display_name,
            paths: placeholder.paths,
            color: repColors[colorIndex]
          };
        });
        res.data.macros.map((macro, index) => {
          let colorIndex = index % macroColors.length;
          vehicles[`macro-${macro.id}`] = {
            name: macro.display_name,
            paths: macro.paths,
            color: macroColors[colorIndex]
          };
        });

        // if (campaign) {
        //   for (let [key, value] of Object.entries(tempCampaignVehicles)) {
        //     for (let [key1, value1] of Object.entries(vehicles)) {
        //       if (key === key1) {
        //         value.paths = value1.paths
        //       }
        //     }
        //   }
        // }
      }


      let res1 = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/truck/analytics`, {
        withCredentials: true
      });
      if (res1.status == 200) {
        res1.data.trucks.map((truck, index) => {
          if (truck.id) {
            analytics[`truck-${truck.id}`] = {
              analytics: truck.analytics
            };
          }
        });
        res1.data.blended.map((blended, index) => {
          if (blended.paths && blended.paths.length > 0) {
            analytics[`blended-${blended.id}`] = {
              analytics: blended.analytics,
            };
          }
        });
        res1.data.placeholders.map((placeholder, index) => {
          analytics[`placeholder-${placeholder.id}`] = {
            paths: placeholder.paths,
          };
        });
        res1.data.macros.map((macro, index) => {
          analytics[`macro-${macro.id}`] = {
            paths: macro.paths
          };
        });


        // fix added for non-converted placeholder campaigns
        for (const [key, analyticsValues] of Object.entries(analytics)) {
          if (key in vehicles) {
            for (const [key1, vehiclesValues] of Object.entries(vehicles)) {
              if (key === key1) {
                vehiclesValues.analytics = analyticsValues.analytics
                if (analyticsValues.paths) {
                  const mergedArray = [];

                  // Loop through each object in analyticsValues array
                  for (let i = 0; i < analyticsValues.paths.length; i++) {
                    let found = false;
                
                    // Loop through each object in vehiclesValues array
                    for (let j = 0; j < vehiclesValues.paths.length; j++) {
                      // Check if there is an overlap in the start and end values
                      if (analyticsValues.paths[i].start === vehiclesValues.paths[j].start && analyticsValues.paths[i].end === vehiclesValues.paths[j].end) {
                        found = true;
                
                        // Merge the objects by copying the distance and impressions keys
                        const mergedObject = { ...vehiclesValues.paths[j], distance: analyticsValues.paths[i].distance, impressions: analyticsValues.paths[i].impressions };
                        // Add the merged object to the mergedArray
                        mergedArray.push(mergedObject);
                
                        // Break the loop as we found an overlap
                        break;
                      }
                    }
                
                    // If no overlap was found, add the whole object from vehiclesValues.paths array
                    if (!found) {
                      mergedArray.push(analyticsValues.paths[i]);
                    }
                  }
                  vehiclesValues.paths = mergedArray
                }
              }
            }
          } else {
            vehicles[key] = analyticsValues
          }
        }
      }
    } catch (err) {
      console.log(err);
    }

    this.setState({
      loading: false
    });
    this.props.updateCampaignVehiclesMapBoxPaths(vehicles)
    return vehicles;
  }

  acceptTermsAndConditions = async (e) => {
    e.preventDefault();
    this.setState({
      acceptTermsAndConditionsLoading: true
    })
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    const data = {
      has_accepted_terms_and_conditions: true
    };

    let userId = this.state.userId;

    axios.patch(`${process.env.REACT_APP_API_HOST}/user/accept-terms-and-conditions/${userId}`, data, config).then((response) => {
      if (response.status === 200 && response.data.updated_user.length > 0) {
        this.setState({
          acceptTermsAndConditionsLoading: false
        })
        console.log(response.data.updated_user);
        localStorage.setItem("has_accepted_terms_and_conditions", JSON.stringify(response.data.updated_user[0].has_accepted_terms_and_conditions));
        window.location.reload();
      }
    });

    
  }

  dismiss = () => {
    this.setState({
      hasAcceptedTermsAndConditions: true
    })
  }

  render() {
    return (
      <Fragment>
        {typeof this.state.hasAcceptedTermsAndConditions !== 'undefined' && !this.state.hasAcceptedTermsAndConditions && 
          <>
            <div className={classes.popupBackdrop}>
            </div>
            <div className={classes.popupContent}>
              {/* <h2>Updated Terms of Service</h2> */}
              <h3>Boxi - Terms of Use</h3>
              <div>
                <br />
                <p>By clicking “I Accept” below, (i) you represent and warrant to Boxi that you have read and that you understand Boxi’s <a href="https://boxi.co/terms.html" target="_blank">Terms of Use</a> and <a href="https://boxi.co/privacy-policy.html" target="_blank">Privacy Policy</a>, (ii) you acknowledge and agree that your access to and use of the Dashboard, including any data or information that is provided or made available to you on or through the Dashboard, are subject to and governed by the  <a href="https://boxi.co/terms.html" target="_blank">Terms of Use</a> and your Advertiser Agreement with Boxi, and that the <a href="https://boxi.co/privacy-policy.html" target="_blank">Privacy Policy</a> applies to use of the Dashboard, and (iii) you agree to follow and be bound by the  <a href="https://boxi.co/terms.html" target="_blank">Terms of Use</a>, without limitation or qualification.  If you do not agree to follow and be bound by the  <a href="https://boxi.co/terms.html" target="_blank">Terms of Use</a>, you may not access or use the Dashboard.</p>
                <br />
              </div>

              <div className={classes.buttons}>
                <Button className={classes.purpleButton} color="primary" onClick={this.acceptTermsAndConditions}>
                  {this.state.acceptTermsAndConditionsLoading ? 
                    <Spinner animation="border" variant="light" size="sm" />
                    :
                    <span>I Accept</span> 
                  }
                </Button>
                <span onClick={() => this.dismiss()} style={{ fontSize: "40px", position: "absolute", left: "30px", color: "white" }}>x</span>
              </div>
            </div>
          </>
        }
        <Header clientInpersonate={false}/>
        <SideBar clientInpersonate={false}/>
        <Content>
          <Switch>
            <PrivateRouteWrapper roles={[1, 2, 3, 4]} path="/dashboard/map" component={MapPageTemp} />
            <PrivateRouteWrapper roles={[1, 2, 3, 4]} path="/dashboard/analytics" component={AnalyticsPageTemp} />
          </Switch>
        </Content>
        <Loading loading={this.state.loading} label="Loading Campaign..." />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.user.id,
    campaigns: state.clientDashboardTemp.campaigns,
    selected: state.clientDashboardTemp.selected,
    timePeriod: state.clientDashboardTemp.timePeriod,
    userProfileUrl: state.clientDashboardTemp.userProfileUrl
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCampaignLoad: (campaigns, selected) => {
      dispatch({
        type: actionTypes.LOAD_CLIENT_CAMPAIGNS,
        campaigns: campaigns,
        selected: selected
      });
    },
    updateCampaignVehiclesTemp: (campaignId, vehicles) => {
      dispatch({
        type: actionTypes.UPDATE_CAMPAIGN_VEHICLES_TEMP,
        id: campaignId,
        vehicles: vehicles,
      });
    },
    updateStartDate: (date, id) =>
      dispatch({
        type: actionTypes.UPDATE_START_DATE,
        startDate: date,
        id: id
      }),
      updateProfilePicture: (userProfileUrl) =>
      dispatch({
        type: actionTypes.UPDATE_PROFILE,
        userProfileUrl: userProfileUrl
      }),
      updateCampaignVehiclesMapBoxPaths: (vehicles) => {
        dispatch({
          type: actionTypes.UPDATE_CAMPAIGN_VEHICLES_MAPBOX,
          vehicles: vehicles
        });
      },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientWrapper));
